/* Gavanna urun detay: hover ile cursor takipli zoom (masaustu). Mobilde devre disi. */
(function () {
  var ZOOM = 2.2; // buyutme orani
  var BREAKPOINT = 1024;
  var initialized = new WeakSet();

  function ensureWrapper(img) {
    if (initialized.has(img)) return;
    initialized.add(img);
    var parent = img.parentElement;
    if (!parent) return;
    // Eski zoom dialog'u devre disi birak
    img.classList.remove("image-zoom-dialog");
    img.removeAttribute("data-image-zoom-dialog");
    img.style.cursor = "zoom-in";

    parent.style.overflow = "hidden";
    parent.classList.add("gv-zoom-host");

    function onMove(e) {
      if (window.innerWidth < BREAKPOINT) return;
      var rect = img.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      x = Math.max(0, Math.min(100, x));
      y = Math.max(0, Math.min(100, y));
      img.style.transformOrigin = x + "% " + y + "%";
      img.style.transform = "scale(" + ZOOM + ")";
    }
    function onEnter() {
      if (window.innerWidth < BREAKPOINT) return;
      img.style.transition = "transform .08s ease-out";
      img.style.willChange = "transform";
    }
    function onLeave() {
      img.style.transform = "";
      img.style.transformOrigin = "";
      img.style.willChange = "";
    }
    parent.addEventListener("mousemove", onMove);
    parent.addEventListener("mouseenter", onEnter);
    parent.addEventListener("mouseleave", onLeave);

    // Mevcut zoom modal'i tetikleyen click'leri yakala
    parent.addEventListener("click", function (e) {
      if (window.innerWidth >= BREAKPOINT) {
        var dlg = e.target.closest("[data-image-zoom-dialog], .image-zoom-dialog");
        if (dlg) {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    }, true);
  }

  function scan() {
    if (!document.body.classList.contains("template-product")) return;
    document.querySelectorAll(
      '[id*="__media-gallery"] img.product-media__image, ' +
      '[id*="__media-gallery"] .product-media img'
    ).forEach(ensureWrapper);
  }

  function init() {
    scan();
    var mo = new MutationObserver(function () {
      clearTimeout(window.__gvZoomT);
      window.__gvZoomT = setTimeout(scan, 200);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
